// Markdown helpers for simulation tickets.
//
// A ticket body is authored markdown that may contain inline placeholders:
// {{credentials}}, {{install-schema}}, {{install-data:key}}, {{task:slug}}.
// parseLessonParts splits the body into an ordered list of prose chunks and
// typed embeds so the ticket can render each. (This mirrors the placeholder
// grammar the live TaskBasedLesson page uses, kept as a self-contained copy.)

const PLACEHOLDER_RE =
  /\{\{(task|quiz|install-data):([a-z0-9-]+)\}\}|\{\{(install-schema|credentials)\}\}/g;

// Turn a markdown body into an ordered list of parts: prose chunks and typed
// embeds (credentials / install / verify-task).
export function parseLessonParts(markdown) {
  const parts = [];
  if (!markdown) return parts;

  let lastIndex = 0;
  let match;
  PLACEHOLDER_RE.lastIndex = 0;

  while ((match = PLACEHOLDER_RE.exec(markdown)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: "markdown", content: markdown.slice(lastIndex, match.index) });
    }

    const itemType = match[1] || match[3]; // task | quiz | install-data | install-schema | credentials
    const slug = match[2];

    if (itemType === "install-schema") {
      parts.push({ type: "action", action: "install-schema" });
    } else if (itemType === "install-data") {
      parts.push({ type: "action", action: "install-data", dataKey: slug });
    } else if (itemType === "credentials") {
      parts.push({ type: "action", action: "credentials" });
    } else if (itemType === "task") {
      parts.push({ type: "task", slug });
    }
    // quizzes don't appear in integration lessons - ignore.

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < markdown.length) {
    parts.push({ type: "markdown", content: markdown.slice(lastIndex) });
  }

  return parts;
}
